<template>
  <div class="fill-height">
    <v-app-bar
      class="elevation-0"
      app
      dark
    >
      <v-toolbar-title class="font-weight-light">
        <slot name="toolbar-title" />
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <slot name="toolbar-icons" />
        <core-user-preferences />
      </v-toolbar-items>

      <template #extension>
        <slot name="extension" />
      </template>
    </v-app-bar>

    <slot />

    <v-footer
      class="pl-12 pr-3 pa-0 grey--text caption"
      height="32px"
      fixed
    >
      <v-row class="align-center justify-center fill-height text-center">
        <v-col style="min-width: 192px; max-width: 192px;" />
        <v-col style="overflow: hidden; text-overflow: ellipsis; width:1px">
          <span style="white-space: nowrap;">
            Komacut&reg; www.komacut.com
            &copy;
            {{ new Date().getFullYear() }}
            <a href="https://www.komacut.com/" target="_blank">
              All Rights Reserved.
            </a>
            Komacut&reg; is a registered trademark of KomaSpect.
            <a href="https://www.komacut.com/" target="_blank">Privacy</a>
            and
            <a href="https://www.komacut.com/" target="_blank">Terms.</a>
          </span>
        </v-col>

        <v-col cols="auto">
          <span>v.{{ appVersion }}</span>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UpdateEntityMixin from '../../mixins/update-entity';
import ServiceMixin from '../../mixins/service';
import TableMixin from '../../mixins/table';
import AuthMixin from '../../mixins/auth';

export default {
  mixins: [
    UpdateEntityMixin,
    ServiceMixin,
    TableMixin,
    AuthMixin,
  ],

  computed: {
    ...mapGetters('app', [
      'appVersion',
    ]),
  },
};
</script>

<style scoped>
/* .avatar {
  width: 32px !important;
  height: 32px !important;
} */
</style>
